module.exports = {
	"_peergroupSeriesOverride": {
		"color": "#aaaaaa",
		"zIndex": 0
	},
	"chart": {
		"type": "line"
	},
	"xAxis": {
		"type": "datetime"
	},
	"yAxis": {
		"visible": false
	},
	"title": {
		"text": null
	},
	"subtitle": {
		"text": null
	},
	"navigator": {
		"enabled": true,
		"adaptToUpdatedData": false
	},
	"legend": {
		"enabled": true,
		"itemMarginBottom": 5
	},
	"rangeSelector": {
		"enabled": true,
		"buttonTheme": {
			"width": 64
		},
		"buttons": [
			{
				"type": "month",
				"count": 1,
				"text": "1 Monat"
			},
			{
				"type": "month",
				"count": 3,
				"text": "3 Monate"
			},
			{
				"type": "year",
				"count": 1,
				"text": "1 Jahr"
			},
			{
				"type": "all",
				"text": "Alles"
			}
		],
		"inputEditDateFormat": "%d.%m.%Y",
		"inputDateFormat": "%e %b %Y"
	},
	"tooltip": {
		"_format": "<b>{{ name }}</b> <br> {{ change }} %"
	},
	"responsive": {
		"rules": [
			{
				"condition": {
					"maxWidth": 360
				},
				"chartOptions": {
					"rangeSelector": {
						"enabled": false
					}
				}
			}
		]
	}
}